module.exports = __webpack_public_path__ + "media/images/pc/visit_reserve/flow-reserve-36f4ac9ec6f3a4e6ab9b62698bd83883.png";